var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6789",
    "data-name": "Rectangle 6789",
    width: 24,
    height: 24,
    transform: "translate(951 581)",
    fill: "#292929"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_112",
    "data-name": "Mask Group 112",
    transform: "translate(-951 -581)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001-fax",
    "data-name": "001-fax",
    transform: "translate(951 581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28605",
    "data-name": "Path 28605",
    d: "M22.139,7.969h-2.03V1.861A1.862,1.862,0,0,0,18.248,0H5.752A1.862,1.862,0,0,0,3.891,1.861V6.834a2.112,2.112,0,0,0-.956,1.134H1.861A1.862,1.862,0,0,0,0,9.83v10.9a1.862,1.862,0,0,0,1.861,1.861H2.934A2.112,2.112,0,0,0,4.922,24h3.75a2.107,2.107,0,0,0,1.987-1.406h11.48A1.862,1.862,0,0,0,24,20.733V9.83A1.862,1.862,0,0,0,22.139,7.969ZM18.7,2.2V7.969H10.659A2.112,2.112,0,0,0,8.672,6.563H5.3V2.2a.8.8,0,0,1,.8-.8H17.906A.8.8,0,0,1,18.7,2.2ZM2.2,9.375h.609V21.188H2.2a.8.8,0,0,1-.8-.8V10.172A.8.8,0,0,1,2.2,9.375ZM8.578,22.594H5.016a.8.8,0,0,1-.8-.8V8.766a.8.8,0,0,1,.8-.8H8.578a.8.8,0,0,1,.8.8V21.8A.8.8,0,0,1,8.578,22.594ZM21.8,21.188H10.781V9.375H21.8a.8.8,0,0,1,.8.8V20.391A.8.8,0,0,1,21.8,21.188Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28606",
    "data-name": "Path 28606",
    d: "M20.2,12.469a.7.7,0,1,1-.7-.7A.7.7,0,0,1,20.2,12.469Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28607",
    "data-name": "Path 28607",
    d: "M17.391,12.469a.7.7,0,1,1-.7-.7A.7.7,0,0,1,17.391,12.469Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28608",
    "data-name": "Path 28608",
    d: "M14.578,12.469a.7.7,0,1,1-.7-.7A.7.7,0,0,1,14.578,12.469Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28609",
    "data-name": "Path 28609",
    d: "M20.2,15.281a.7.7,0,1,1-.7-.7A.7.7,0,0,1,20.2,15.281Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28610",
    "data-name": "Path 28610",
    d: "M17.391,15.281a.7.7,0,1,1-.7-.7A.7.7,0,0,1,17.391,15.281Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28611",
    "data-name": "Path 28611",
    d: "M14.578,15.281a.7.7,0,1,1-.7-.7A.7.7,0,0,1,14.578,15.281Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28612",
    "data-name": "Path 28612",
    d: "M20.2,18.094a.7.7,0,1,1-.7-.7A.7.7,0,0,1,20.2,18.094Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28613",
    "data-name": "Path 28613",
    d: "M17.391,18.094a.7.7,0,1,1-.7-.7A.7.7,0,0,1,17.391,18.094Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28614",
    "data-name": "Path 28614",
    d: "M14.578,18.094a.7.7,0,1,1-.7-.7A.7.7,0,0,1,14.578,18.094Z",
    fill: "#292929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFax);
export default __webpack_public_path__ + "static/media/contact_fax.912c99591af04ee58ece0905ca1d969a.svg";
export { ForwardRef as ReactComponent };